<script lang="ts" setup>
import { inject } from 'vue';

import type { Ref } from 'vue';

const envMapPath = inject('envMapPath') as Ref<string>;
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="envmap-path" class="text-xs mr-2">Path</label>
    <input id="envmap-path" v-model="envMapPath" type="text" class="border p-1 text-xs flex-grow">
  </div>
</template>
